/**
 * 
 * @param {*} version 版本号
 * @param {*} appType  'GKZTC' 高考直通车 'GKZTCZY' 高考直通车志愿版
 * @returns 
 */
var checkAppVersion = function (version,appType) {
  var navi = navigator.userAgent
  var str = navi.indexOf(appType?appType:'GKZTC')
  var res = 0
  if (str > -1) {
      //是APP里面打开的网页
      var a = navi.match(/iOS\/(\d+?\.\d+?\.\d+?)[_-]/)
      var b = navi.match(/Android\/(\d+?\.\d+?\.\d+?)[_-]/)

        // 判断GKZTC后两个/后版本号的方式的正则解释：
        // GKZTC\/ - 匹配 "GKZTC/"
        // [^\/]+\/ - 匹配任意非斜杠字符，直到下一个斜杠
        // (\d+\.\d+\.\d+) - 捕获版本号(x.x.x格式)
        // (?=_|\/)- 正向断言，要求版本号后面是下划线或斜杠
        // var d = navi.match(/GKZTC\/[^\/]+\/(\d+\.\d+\.\d+)(?=_|\/)/);
        // if(d && d[1]) {
        //   console.log(d[1]) // 输出: 8.6.0
        // }
      var c = null
      if (a !== null) {
          c = a
      }
      if (b !== null) {
          c = b
      }
      // 兼容鸿蒙版本不一样的问题
      if (c === null) {
        return -1
      }
      var arr = c[1].split(".")
      var brr = version.split(".")
      for (var i = 0; i < 3; i++) {
          if (arr[i] -  brr[i] > 0) {
            res = 1
            break;
          }
          if (arr[i] -  brr[i] < 0) {
            res = -1
            break;
          }
      }
      
  }
  return res
}

export default checkAppVersion